export default function HeroSection() {
  return (
    <section
      id="header"
      className="relative w-full min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ac55b7e2fba3c14d8f55414247c3b8b1.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full flex flex-col items-center text-center px-6 md:px-12 pt-20">
        <span className="inline-block text-xs uppercase tracking-widest text-white/60 mb-6 font-medium">
          iOS Application Development
        </span>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight max-w-4xl">
          Modern iOS Applications
          <br />
          <em className="not-italic font-light text-white/80">Built for Excellence</em>
        </h1>
        <p className="mt-6 text-base md:text-lg text-white/70 max-w-xl leading-relaxed">
          FORMO d.o.o. is a team of experts crafting premium iOS experiences — from powerful VPN solutions to intelligent device optimization tools.
        </p>

        {/* Scroll indicator */}
        <div className="mt-16 flex flex-col items-center gap-2 animate-bounce">
          <span className="text-white/40 text-xs uppercase tracking-widest">Scroll</span>
          <i className="ri-arrow-down-line text-white/40 text-xl" />
        </div>
      </div>
    </section>
  );
}
